import { get } from 'lodash';
import { NumberFormat } from '../panda';

interface INumberTypeOptions {
  numberFormat: NumberFormat;
  precision: number;
}

export const getFormattedNumber = (value: number, typeOptions: INumberTypeOptions) => {
  const precision = typeOptions ? typeOptions.precision : 0;
  const numberFormat = get(typeOptions, 'numberFormat', NumberFormat.DECIMAL);

  switch (numberFormat) {
    case NumberFormat.DECIMAL:
      return typeof value === 'number' ? value.toFixed(precision) : '';
    case NumberFormat.PERCENTAGE:
      return getFormattedPercentage(value, typeOptions);
    case NumberFormat.DECIMAL_WITH_COMMAS:
      return getFormattedNumberWithCommas(value, typeOptions);
    default:
      return '';
  }
};

export const getFormattedPercentage = (value: number, typeOptions: INumberTypeOptions) => {
  const precision = typeOptions ? typeOptions.precision : 0;
  if (typeof value !== 'number' || isNaN(value)) return '';
  return `${(value * 100).toFixed(precision)}%`;
};

export const getFormattedNumberWithCommas = (value: number, typeOptions: INumberTypeOptions) => {
  const { precision } = typeOptions;
  return typeof value === 'number'
    ? value.toLocaleString('en', {
        maximumFractionDigits: precision,
        minimumFractionDigits: precision,
      })
    : '';
};

export const getFormattedArrayNumber = (values: number[], typeOptions: INumberTypeOptions) =>
  (values && Array.isArray(values) ? values : [])
    .map((num: number) => getFormattedNumber(num, typeOptions))
    .join(', ');
